import React, {Component} from 'react';
import { BrowserRouter, Route, Switch , Redirect, RouteProps, RouteComponentProps} from 'react-router-dom';
import { isSigned } from '../contexts/auth';


const DefaultLayout = React.lazy(() => import('../container/DefaultLayout'));
const Login = React.lazy(() => import('../pages/Login/Login'));
const ResetarSenha = React.lazy(() => import('../pages/ResetarSenha/ResetarSenha'));



interface PrivateRouteProps extends RouteProps{
  signed: boolean
}

const PrivateRoute = (component: PrivateRouteProps) => {
  const {signed} = component;
  return(
    <Route
      {...component}
      render={props => (
        signed 
          ? <DefaultLayout {...props} />  
          : <Redirect to={{ pathname: "/login", state: { from: props.location } }} /> 
      )}
    />
  )
};




const loading = () => <div className="animated fadeIn pt-1 text-center">Carregando...</div>

const Routes = () => {
  const signed = isSigned();
  return (
    <BrowserRouter>
       <React.Suspense fallback={loading()}>
          <Switch>
            <Route path="/login" exact={true} render={props=> {
              return (!signed) 
                        ? <Login {...props} />  
                        : <DefaultLayout {...props} />  
            } }/>
            <Route path="/auth/change-password/:token" render={props=> <ResetarSenha /> }/> 
            <PrivateRoute signed={signed} path="/" render={props => <DefaultLayout {...props} />} />
          </Switch>
        </React.Suspense>
    </BrowserRouter>
  );
}

export default Routes;
/*
export default function Routes() {

  const { signed } = useAuth();

  return (
    <BrowserRouter>
      {signed 
        ? <AppRoutes /> 
        : <AuthRoutes />
      }
    </BrowserRouter>
  );
}
*/